import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/roles',
    name: 'roles.index',
    component: () => import('./views/RolesIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'roles.read',
      breadcrumb: 'Roles',
    },
  },
  {
    path: '/admin/roles/:id/policies',
    name: 'roles.policies',
    component: () => import('./views/RolePoliciesView.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'roles.update',
      breadcrumb: 'Permisos',
    },
  },
]

export default routes
